import * as tslib_1 from "tslib";
import getAutoReplyStatus from '../utils/getAutoReplyStatus';
import getCreateOofEventStatus from '../utils/getCreateOofEventStatus';
import getOofEventSubject from '../utils/getOofEventSubject';
import getExternalMessage from '../utils/getExternalMessage';
import getInternalMessage from '../utils/getInternalMessage';
import getDeclineMeetingMessage from '../utils/getDeclineMeetingMessage';
import getExternalAudience from '../utils/getExternalAudience';
import getDeclineNewReqestStatus from '../utils/getDeclineNewReqestStatus';
import getDeclineEventsForScheduled from '../utils/getDeclineEventsForScheduled';
import getDataForInitialState from '../utils/getDataForInitialState';
import getStartDateTime from '../utils/getStartDateTime';
import getEndDateTime from '../utils/getEndDateTime';
import getEventsToDelete from '../utils/getEventsToDelete';
import updateAutomaticRepliesInitialState from '../data/mutators/updateAutomaticRepliesInitialState';
import saveMailboxAutomaticRepliesConfiguration from '../services/saveMailboxAutomaticRepliesConfiguration';
import logDataOnSaveAutomaticReplies from '../utils/logDataOnSaveAutomaticReplies';
import strings from 'owa-strings/owa-options-strings';
import { confirm } from 'owa-confirm-dialog';
/**
 * Method that saves the mailbox autoreply configuration also updates the initial state on success.
 */
export default function saveAutomaticRepliesOption() {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var autoReplyStatus, isDeclinedEventsChecked, eventsToDelete, mailboxAutoReplyConfigurationOptions;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    autoReplyStatus = getAutoReplyStatus();
                    isDeclinedEventsChecked = getDeclineEventsForScheduled();
                    eventsToDelete = getEventsToDelete();
                    mailboxAutoReplyConfigurationOptions = null;
                    if (autoReplyStatus == 0 /* Disabled */) {
                        mailboxAutoReplyConfigurationOptions = {
                            AutoReplyState: autoReplyStatus,
                            ExternalAudience: getExternalAudience(),
                        };
                    }
                    else {
                        mailboxAutoReplyConfigurationOptions = {
                            AutoReplyState: autoReplyStatus,
                            CreateOOFEvent: getCreateOofEventStatus(),
                            OOFEventSubject: getOofEventSubject(),
                            ExternalMessage: getExternalMessage(),
                            InternalMessage: getInternalMessage(),
                            ExternalAudience: getExternalAudience(),
                            AutoDeclineFutureRequestsWhenOOF: getDeclineNewReqestStatus(),
                            DeclineEventsForScheduledOOF: isDeclinedEventsChecked,
                            DeclineMeetingMessage: getDeclineMeetingMessage(),
                            StartTime: getStartDateTime(),
                            EndTime: getEndDateTime(),
                            EventsToDeleteIDs: eventsToDelete,
                        };
                    }
                    if (isDeclinedEventsChecked && eventsToDelete.length > 0) {
                        confirm('', strings.options_automaticReplies_emailReplies_cancel_meetings_dialogMessage, false, {
                            hideCancelButton: true,
                        });
                    }
                    return [4 /*yield*/, saveMailboxAutomaticRepliesConfiguration(mailboxAutoReplyConfigurationOptions).then(function () {
                            logDataOnSaveAutomaticReplies();
                            updateAutomaticRepliesInitialState(getDataForInitialState());
                        })];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}
//# sourceMappingURL=saveAutomaticRepliesOption.js.map